// extracted by mini-css-extract-plugin
export default {"subHeader":"styles__subHeader__f7e593de7be6858b6496","sectionHeading":"styles__sectionHeading__a1e74c24dba41130d3d0","section":"styles__section__a6090297e1d7e9272c51"};